import { useAppSelector } from '../../app/hooks';
import { selectUser } from '../auth/selectors';

export const useReferOrgInfo = () => {
    const userInfo = useAppSelector(selectUser);
    const camhsChild = userInfo.partnerCamhsChildren && userInfo.partnerCamhsChildren[0];
    const includeReferOrg = !!camhsChild && camhsChild.addToCareTeamOnLink === 'REFERRING_PARTNER_ORG_UNIT';
    const referOrgId = camhsChild?.referralOrgUnit.id;
    const referOrgName = (camhsChild?.referralOrgUnit.fullName || 'unknown').split('/').slice(1).join(' / ');
    return {
        includeReferOrg,
        referOrgId,
        referOrgName,
    };
};
